// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Content / SEO landing pages — aligned with CookandChef brand */

.ContentPages_page__Xe6GN {
  background: #ffffff;
  color: #1e293b;
}

.ContentPages_container__DVDeq {
  max-width: 1120px;
  margin: 0 auto;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

/* —— Breadcrumb —— */
.ContentPages_breadcrumb__prZoY {
  max-width: 1120px;
  margin: 0 auto;
  padding: 1.25rem 1.25rem 0;
}

.ContentPages_breadcrumbList__f4nNQ {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 0.875rem;
  color: #64748b;
}

.ContentPages_breadcrumbLink__s6Hu- {
  color: #e25c1d;
  text-decoration: none;
}

.ContentPages_breadcrumbLink__s6Hu-:hover {
  text-decoration: underline;
}

.ContentPages_breadcrumbSep__JKgRo {
  color: #cbd5e1;
}

.ContentPages_breadcrumbCurrent__rvHpQ {
  color: #0f172a;
  font-weight: 500;
}

/* —— Hero —— */
.ContentPages_hero__nkQg3 {
  padding: 2.5rem 0 2rem;
  text-align: center;
}

.ContentPages_heroWide__nvvNp {
  text-align: left;
}

.ContentPages_heroEyebrow__F4k1Y {
  display: inline-block;
  margin-bottom: 0.75rem;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  background: #fff0eb;
  color: #e25c1d;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.ContentPages_heroTitle__92mQY {
  font-size: clamp(2rem, 4.5vw, 3rem);
  font-weight: 700;
  line-height: 1.15;
  margin: 0 0 1.25rem;
  color: #0f172a;
}

.ContentPages_heroAccent__tXG-E {
  color: #e25c1d;
}

.ContentPages_heroSubtitle__jgUgQ {
  max-width: 720px;
  margin: 0 auto 1.75rem;
  font-size: clamp(1rem, 2vw, 1.125rem);
  line-height: 1.7;
  color: #64748b;
}

.ContentPages_heroWide__nvvNp .ContentPages_heroSubtitle__jgUgQ {
  margin-left: 0;
}

.ContentPages_ctaRow__GkMYZ {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
}

.ContentPages_heroWide__nvvNp .ContentPages_ctaRow__GkMYZ {
  justify-content: flex-start;
}

.ContentPages_btnPrimary__S4GiF,
.ContentPages_btnSecondary__b3g2l {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 48px;
  padding: 0.75rem 1.35rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  border: 2px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.ContentPages_btnPrimary__S4GiF {
  background: #e25c1d;
  color: #ffffff;
}

.ContentPages_btnPrimary__S4GiF:hover {
  background: #c94e14;
  color: #ffffff;
}

.ContentPages_btnSecondary__b3g2l {
  background: #ffffff;
  color: #e25c1d;
  border-color: #e25c1d;
}

.ContentPages_btnSecondary__b3g2l:hover {
  background: #fff0eb;
  color: #c94e14;
}

.ContentPages_btnGhost__vJxat {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: none;
  border: none;
  color: #e25c1d;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  padding: 0;
  text-decoration: none;
}

.ContentPages_btnGhost__vJxat:hover {
  text-decoration: underline;
}

/* —— Sections —— */
.ContentPages_section__L6GVF {
  padding: 2.5rem 0;
}

.ContentPages_sectionAlt__0EWE7 {
  background: #f8fafc;
  padding: 2.75rem 0;
}

.ContentPages_sectionHeader__SPlCp {
  text-align: center;
  margin-bottom: 2rem;
}

.ContentPages_sectionTitle__3eUVc {
  font-size: clamp(1.5rem, 3vw, 1.875rem);
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.65rem;
}

.ContentPages_sectionSubtitle__XLWYe {
  max-width: 640px;
  margin: 0 auto;
  color: #64748b;
  line-height: 1.65;
  font-size: 1.05rem;
}

/* —— Category / feature cards —— */
.ContentPages_cardGrid__AIHnP {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
}

.ContentPages_cardGrid3__mTXX3 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.25rem;
}

.ContentPages_card__1ViuB {
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  padding: 1.75rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  height: 100%;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: inherit;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

a.ContentPages_card__1ViuB:hover {
  border-color: #fdba8c;
  box-shadow: 0 12px 28px rgba(226, 92, 29, 0.1);
}

.ContentPages_cardIcon__Q01Lb {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  background: #fff0eb;
  color: #e25c1d;
  flex-shrink: 0;
}

.ContentPages_cardTitle__3h6ry {
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.5rem;
}

.ContentPages_cardText__X2gjm {
  margin: 0 0 1rem;
  color: #64748b;
  line-height: 1.6;
  flex: 1 1;
}

.ContentPages_cardLink__pFBj4 {
  color: #e25c1d;
  font-weight: 600;
  font-size: 0.95rem;
}

/* —— Trust / signal row —— */
.ContentPages_signalList__MK1TY {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.25rem;
}

.ContentPages_signalItem__tXiF8 {
  text-align: center;
  padding: 1.5rem 1rem;
}

.ContentPages_signalItem__tXiF8 h3 {
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0.75rem 0 0.4rem;
}

.ContentPages_signalItem__tXiF8 p {
  margin: 0;
  color: #64748b;
  line-height: 1.55;
  font-size: 0.95rem;
}

/* —— Inquiry module —— */
.ContentPages_inquiryWrap__JQbN2 {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 2rem;
  align-items: start;
}

.ContentPages_inquiryPanel__xHC30 {
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  padding: 1.75rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}

.ContentPages_inquiryPanel__xHC30 h2 {
  font-size: 1.35rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
  color: #0f172a;
}

.ContentPages_inquiryPanel__xHC30 > p {
  margin: 0 0 1.25rem;
  color: #64748b;
  line-height: 1.55;
}

.ContentPages_formGrid__b\\+-vU {
  display: grid;
  gap: 0.85rem;
}

.ContentPages_formField__mBi6x label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #334155;
  margin-bottom: 0.35rem;
}

.ContentPages_formField__mBi6x input,
.ContentPages_formField__mBi6x select,
.ContentPages_formField__mBi6x textarea {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.65rem 0.85rem;
  font-size: 0.95rem;
  color: #0f172a;
  background: #fff;
  font-family: inherit;
}

.ContentPages_formField__mBi6x input:focus,
.ContentPages_formField__mBi6x select:focus,
.ContentPages_formField__mBi6x textarea:focus {
  outline: 2px solid rgba(226, 92, 29, 0.35);
  border-color: #e25c1d;
}

.ContentPages_formField__mBi6x textarea {
  min-height: 96px;
  resize: vertical;
}

.ContentPages_formNote__Lxpwd {
  margin: 0.75rem 0 0;
  font-size: 0.8rem;
  color: #94a3b8;
}

.ContentPages_formSuccess__v7bMP {
  margin: 0.75rem 0 0;
  color: #15803d;
  font-size: 0.9rem;
  font-weight: 500;
}

/* —— Benefits list —— */
.ContentPages_benefitList__\\+iZlY {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 1rem;
}

.ContentPages_benefitItem__9PyJE {
  display: flex;
  gap: 0.85rem;
  align-items: flex-start;
  padding: 1rem 1.15rem;
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 12px;
}

.ContentPages_benefitItem__9PyJE strong {
  display: block;
  color: #0f172a;
  margin-bottom: 0.2rem;
}

.ContentPages_benefitItem__9PyJE span {
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.5;
}

/* —— FAQ —— */
.ContentPages_faqList__BrIUl {
  max-width: 800px;
  margin: 0 auto;
  display: grid;
  gap: 0.65rem;
}

.ContentPages_faqItem__Tlu\\+J {
  border: 1px solid #eef2f7;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.ContentPages_faqQuestion__qowiv {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.15rem;
  background: none;
  border: none;
  text-align: left;
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
  cursor: pointer;
  font-family: inherit;
}

.ContentPages_faqQuestion__qowiv:hover {
  background: #f8fafc;
}

.ContentPages_faqIcon__vavdu {
  flex-shrink: 0;
  color: #e25c1d;
  transition: transform 0.2s ease;
}

.ContentPages_faqIconOpen__tV--o {
  transform: rotate(180deg);
}

.ContentPages_faqAnswer__0dEKx {
  padding: 0 1.15rem 1.1rem;
  color: #64748b;
  line-height: 1.65;
  font-size: 0.975rem;
}

/* —— Footer CTA band —— */
.ContentPages_ctaBand__PcH0j {
  background: linear-gradient(135deg, #fff7f2 0%, #fff0eb 50%, #f8fafc 100%);
  padding: 3rem 0;
  text-align: center;
}

.ContentPages_ctaBand__PcH0j h2 {
  font-size: clamp(1.4rem, 3vw, 1.75rem);
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.65rem;
}

.ContentPages_ctaBand__PcH0j p {
  max-width: 560px;
  margin: 0 auto 1.5rem;
  color: #64748b;
  line-height: 1.6;
}

/* —— Page footer strip —— */
.ContentPages_pageFooter__hkrdz {
  border-top: 1px solid #eef2f7;
  padding: 1.5rem 0;
  text-align: center;
  font-size: 0.875rem;
  color: #94a3b8;
}

.ContentPages_pageFooter__hkrdz a {
  color: #e25c1d;
  text-decoration: none;
}

.ContentPages_pageFooter__hkrdz a:hover {
  text-decoration: underline;
}

/* —— Salary / educational content —— */
.ContentPages_proseSection__DU-gz {
  padding: 2.75rem 0;
}

.ContentPages_proseNarrow__yiX1Q {
  max-width: 820px;
  margin: 0 auto;
}

.ContentPages_proseLead__LAbq2 {
  font-size: 1.05rem;
  line-height: 1.75;
  color: #475569;
  margin: 0 0 1.75rem;
}

.ContentPages_proseBlock__nrMdr {
  margin-bottom: 2.25rem;
}

.ContentPages_proseBlock__nrMdr h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.65rem;
}

.ContentPages_proseBlock__nrMdr h4 {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1e293b;
  margin: 1.25rem 0 0.5rem;
}

.ContentPages_proseBlock__nrMdr p {
  margin: 0 0 0.85rem;
  color: #475569;
  line-height: 1.7;
}

.ContentPages_metaRow__VlrQa {
  display: grid;
  gap: 0.45rem;
  margin: 0 0 1rem;
  padding: 0.9rem 1rem;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 10px;
}

.ContentPages_metaRow__VlrQa span {
  color: #334155;
  font-size: 0.95rem;
  line-height: 1.5;
}

.ContentPages_metaRow__VlrQa strong {
  color: #0f172a;
}

.ContentPages_bulletList__26OoQ {
  margin: 0.5rem 0 1rem;
  padding-left: 1.2rem;
  color: #475569;
  line-height: 1.7;
}

.ContentPages_bulletList__26OoQ li {
  margin-bottom: 0.4rem;
}

.ContentPages_tableWrap__l3Xbk {
  overflow-x: auto;
  margin: 1.25rem 0 2rem;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}

.ContentPages_salaryTable__6vjj6 {
  width: 100%;
  border-collapse: collapse;
  min-width: 640px;
  background: #ffffff;
}

.ContentPages_salaryTable__6vjj6 th,
.ContentPages_salaryTable__6vjj6 td {
  padding: 0.9rem 1rem;
  text-align: left;
  border-bottom: 1px solid #eef2f7;
  font-size: 0.925rem;
  vertical-align: top;
}

.ContentPages_salaryTable__6vjj6 th {
  background: #fff7f2;
  color: #0f172a;
  font-weight: 700;
  white-space: nowrap;
}

.ContentPages_salaryTable__6vjj6 tbody tr:last-child td {
  border-bottom: none;
}

.ContentPages_salaryTable__6vjj6 tbody tr:hover td {
  background: #fafafa;
}

.ContentPages_factorGrid__1KoId {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.15rem;
  margin-top: 1.25rem;
}

.ContentPages_factorCard__ZSy5- {
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  padding: 1.35rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}

.ContentPages_factorCard__ZSy5- h3 {
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.5rem;
}

.ContentPages_factorCard__ZSy5- p {
  margin: 0;
  color: #64748b;
  line-height: 1.6;
  font-size: 0.95rem;
}

.ContentPages_inlineCta__g4eW2 {
  margin-top: 2rem;
  padding: 1.5rem;
  border-radius: 14px;
  background: linear-gradient(135deg, #fff7f2 0%, #ffffff 100%);
  border: 1px solid #fde6d8;
  text-align: center;
}

.ContentPages_inlineCta__g4eW2 p {
  margin: 0 0 1rem;
  color: #475569;
  line-height: 1.6;
}

/* —— Above-footer: resources + app download (not site footer) —— */
.ContentPages_preFooter__2fuwt {
  background: #fff5f0;
  border-top: 1px solid #fde8dc;
  padding: 2.75rem 0 3rem;
}

.ContentPages_preFooterInner__Ce\\+Jl {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 1.25rem;
  display: grid;
  grid-template-columns: 1fr 1.05fr;
  gap: 2.5rem;
  align-items: center;
}

.ContentPages_preFooterLinks__7I1\\+y {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.ContentPages_preFooterCol__bl5cv {
  min-width: 0;
}

.ContentPages_preFooterHeading__3uAze {
  margin: 0 0 1rem;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #0f172a;
}

.ContentPages_preFooterList__mEC-p {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.65rem;
}

.ContentPages_preFooterList__mEC-p a {
  color: #64748b;
  text-decoration: none;
  font-size: 0.975rem;
  line-height: 1.4;
}

.ContentPages_preFooterList__mEC-p a:hover {
  color: #e25c1d;
  text-decoration: underline;
}

.ContentPages_appDownloadCard__ONYzJ {
  background: #ffffff;
  border-radius: 16px;
  padding: 1.75rem 1.5rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
}

.ContentPages_appDownloadTitle__-3a-h {
  margin: 0 0 0.5rem;
  font-size: clamp(1.15rem, 2.2vw, 1.4rem);
  font-weight: 700;
  line-height: 1.35;
  color: #0f172a;
}

.ContentPages_appDownloadSubtext__W8NlG {
  margin: 0 0 1.25rem;
  font-size: 0.975rem;
  color: #64748b;
  line-height: 1.5;
}

.ContentPages_appBadgeRow__j6-wc {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
}

.ContentPages_appBadgeLink__5\\+Bqp {
  display: inline-flex;
  line-height: 0;
}

.ContentPages_appBadge__Ie66x {
  height: 44px;
  width: auto;
  max-width: 160px;
  object-fit: contain;
  display: block;
}

.ContentPages_proTip__inTSk {
  margin: 1rem 0 0;
  padding: 0.9rem 1rem;
  border-left: 3px solid #e25c1d;
  background: #fff7f2;
  border-radius: 0 10px 10px 0;
  color: #475569;
  line-height: 1.6;
  font-size: 0.95rem;
}

.ContentPages_stepList__0V28I {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 1.5rem;
  counter-reset: hire-step;
}

.ContentPages_stepCard__POC37 {
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  padding: 1.5rem 1.5rem 1.35rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  counter-increment: hire-step;
}

.ContentPages_stepCard__POC37 h2 {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.85rem;
  line-height: 1.35;
}

.ContentPages_stepCard__POC37 h2::before {
  content: counter(hire-step);
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 999px;
  background: #fff0eb;
  color: #e25c1d;
  font-size: 0.9rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.1rem;
}

.ContentPages_stepCard__POC37 > p {
  margin: 0 0 0.85rem;
  color: #475569;
  line-height: 1.7;
}

.ContentPages_stepCard__POC37 h3 {
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  margin: 1rem 0 0.5rem;
}

.ContentPages_orderedQuestions__kyaTL {
  margin: 0.5rem 0 0;
  padding-left: 1.25rem;
  color: #475569;
  line-height: 1.7;
}

.ContentPages_orderedQuestions__kyaTL li {
  margin-bottom: 0.55rem;
}

/* —— Knowledge Hub (sticky sidebar + content) —— */
.ContentPages_hubHero__bp8PM {
  padding: 2rem 0 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
}

.ContentPages_hubHeroInner__nINTz {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 1.25rem;
}

.ContentPages_hubHero__bp8PM .ContentPages_heroTitle__92mQY {
  text-align: left;
  margin-bottom: 0.85rem;
}

.ContentPages_hubHero__bp8PM .ContentPages_heroSubtitle__jgUgQ {
  margin: 0 0 1.25rem;
  max-width: 720px;
  text-align: left;
}

.ContentPages_hubHero__bp8PM .ContentPages_ctaRow__GkMYZ {
  justify-content: flex-start;
}

.ContentPages_hubBody__owwup {
  max-width: 1120px;
  margin: 0 auto;
  padding: 1.75rem 1.25rem 3rem;
  display: grid;
  grid-template-columns: minmax(200px, 1fr) minmax(0, 3fr);
  gap: 2rem;
  align-items: start;
}

.ContentPages_hubSidebar__QBUzw {
  position: sticky;
  top: 5rem;
  align-self: start;
  max-height: calc(100vh - 6rem);
  overflow-y: auto;
  padding: 0.25rem 0;
}

.ContentPages_hubNavLabel__KFina {
  margin: 0 0 0.75rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
  padding-left: 0.85rem;
}

.ContentPages_hubNavList__X0nYJ {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  border-left: 1px solid #e2e8f0;
}

.ContentPages_hubNavLink__CoIgV {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.65rem 0.85rem;
  border: none;
  border-left: 4px solid transparent;
  margin-left: -1px;
  background: transparent;
  color: #64748b;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.35;
  cursor: pointer;
  font-family: inherit;
  text-decoration: none;
  border-radius: 0 8px 8px 0;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.ContentPages_hubNavLink__CoIgV:hover {
  color: #e25c1d;
  background: #fff7f2;
}

.ContentPages_hubNavLinkActive__miBgj {
  border-left-color: #f97316;
  background: #fff7ed;
  color: #ea580c;
  font-weight: 600;
}

.ContentPages_hubMain__0hLxs {
  min-width: 0;
  display: grid;
  gap: 1.25rem;
}

.ContentPages_hubTopic__poeqb {
  scroll-margin-top: 6rem;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 1.5rem 1.5rem 1.35rem;
  background: #ffffff;
}

.ContentPages_hubTopicHeader__V\\+uSt {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.75rem;
}

.ContentPages_hubTopicHeader__V\\+uSt h2 {
  margin: 0;
  font-size: clamp(1.2rem, 2.4vw, 1.45rem);
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.ContentPages_hubBadge__ZjF3L {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  background: #fff0eb;
  color: #e25c1d;
  border: 1px solid #fde6d8;
}

.ContentPages_hubBadgeGuide__Kqnad {
  background: #eff6ff;
  color: #2563eb;
  border-color: #dbeafe;
}

.ContentPages_hubBadgeOps__xN3CU {
  background: #f0fdf4;
  color: #15803d;
  border-color: #bbf7d0;
}

.ContentPages_hubBadgeHire__rP8uE {
  background: #faf5ff;
  color: #7c3aed;
  border-color: #e9d5ff;
}

.ContentPages_hubSummary__h3s4y {
  margin: 0 0 1rem;
  color: #475569;
  line-height: 1.7;
  font-size: 0.975rem;
}

.ContentPages_hubTopic__poeqb .ContentPages_bulletList__26OoQ {
  margin-bottom: 1.15rem;
}

.ContentPages_hubTopic__poeqb .ContentPages_salaryTable__6vjj6 {
  min-width: 480px;
}

.ContentPages_hubTopic__poeqb .ContentPages_tableWrap__l3Xbk {
  margin: 0 0 1.15rem;
}

.ContentPages_hubTopicCtas__3WE90 {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  margin-top: 0.25rem;
}

.ContentPages_hubQuickCards__INC-0 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.85rem;
  margin: 0 0 1.15rem;
}

.ContentPages_hubQuickCard__zCAcH {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.9rem 1rem;
  background: #f8fafc;
}

.ContentPages_hubQuickCard__zCAcH strong {
  display: block;
  color: #0f172a;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.ContentPages_hubQuickCard__zCAcH span {
  color: #64748b;
  font-size: 0.85rem;
  line-height: 1.45;
}

@media (max-width: 900px) {
  .ContentPages_factorGrid__1KoId,
  .ContentPages_cardGrid3__mTXX3,
  .ContentPages_signalList__MK1TY,
  .ContentPages_hubQuickCards__INC-0 {
    grid-template-columns: 1fr;
  }

  .ContentPages_inquiryWrap__JQbN2,
  .ContentPages_preFooterInner__Ce\\+Jl {
    grid-template-columns: 1fr;
  }

  .ContentPages_hubBody__owwup {
    grid-template-columns: 1fr;
    gap: 1.25rem;
    padding-top: 1.25rem;
  }

  .ContentPages_hubSidebar__QBUzw {
    position: sticky;
    top: 3.5rem;
    z-index: 20;
    max-height: none;
    overflow: visible;
    margin: 0 -1.25rem;
    padding: 0.65rem 0;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
  }

  .ContentPages_hubNavLabel__KFina {
    display: none;
  }

  .ContentPages_hubNavList__X0nYJ {
    flex-direction: row;
    overflow-x: auto;
    gap: 0.4rem;
    border-left: none;
    padding: 0 1.25rem 0.35rem;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
  }

  .ContentPages_hubNavLink__CoIgV {
    flex: 0 0 auto;
    white-space: nowrap;
    border-left: none;
    border-bottom: 3px solid transparent;
    margin-left: 0;
    border-radius: 8px;
    padding: 0.55rem 0.85rem;
    background: #f8fafc;
  }

  .ContentPages_hubNavLinkActive__miBgj {
    border-left-color: transparent;
    border-bottom-color: #f97316;
    background: #fff7ed;
  }
}

@media (max-width: 640px) {
  .ContentPages_cardGrid__AIHnP {
    grid-template-columns: 1fr;
  }

  .ContentPages_hero__nkQg3 {
    padding-top: 1.75rem;
  }

  .ContentPages_ctaRow__GkMYZ {
    flex-direction: column;
  }

  .ContentPages_btnPrimary__S4GiF,
  .ContentPages_btnSecondary__b3g2l {
    width: 100%;
  }

  .ContentPages_preFooterLinks__7I1\\+y {
    grid-template-columns: 1fr;
    gap: 1.75rem;
  }

  .ContentPages_appBadge__Ie66x {
    height: 42px;
    max-width: 148px;
  }

  .ContentPages_hubTopic__poeqb {
    padding: 1.25rem 1.1rem;
  }

  .ContentPages_hubTopicCtas__3WE90 .ContentPages_btnPrimary__S4GiF,
  .ContentPages_hubTopicCtas__3WE90 .ContentPages_btnSecondary__b3g2l {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/ContentPages.module.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;EAGE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,0EAA0E;EAC1E,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,6CAA6C;EAC7C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,0BAA0B;EAC1B,4EAA4E;AAC9E;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;;;;IAIE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,0BAA0B;IAC1B,iCAAiC;IACjC,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,4BAA4B;IAC5B,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* Content / SEO landing pages — aligned with CookandChef brand */\n\n.page {\n  background: #ffffff;\n  color: #1e293b;\n}\n\n.container {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n\n/* —— Breadcrumb —— */\n.breadcrumb {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 1.25rem 1.25rem 0;\n}\n\n.breadcrumbList {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-size: 0.875rem;\n  color: #64748b;\n}\n\n.breadcrumbLink {\n  color: #e25c1d;\n  text-decoration: none;\n}\n\n.breadcrumbLink:hover {\n  text-decoration: underline;\n}\n\n.breadcrumbSep {\n  color: #cbd5e1;\n}\n\n.breadcrumbCurrent {\n  color: #0f172a;\n  font-weight: 500;\n}\n\n/* —— Hero —— */\n.hero {\n  padding: 2.5rem 0 2rem;\n  text-align: center;\n}\n\n.heroWide {\n  text-align: left;\n}\n\n.heroEyebrow {\n  display: inline-block;\n  margin-bottom: 0.75rem;\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  background: #fff0eb;\n  color: #e25c1d;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.heroTitle {\n  font-size: clamp(2rem, 4.5vw, 3rem);\n  font-weight: 700;\n  line-height: 1.15;\n  margin: 0 0 1.25rem;\n  color: #0f172a;\n}\n\n.heroAccent {\n  color: #e25c1d;\n}\n\n.heroSubtitle {\n  max-width: 720px;\n  margin: 0 auto 1.75rem;\n  font-size: clamp(1rem, 2vw, 1.125rem);\n  line-height: 1.7;\n  color: #64748b;\n}\n\n.heroWide .heroSubtitle {\n  margin-left: 0;\n}\n\n.ctaRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  justify-content: center;\n}\n\n.heroWide .ctaRow {\n  justify-content: flex-start;\n}\n\n.btnPrimary,\n.btnSecondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-height: 48px;\n  padding: 0.75rem 1.35rem;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  text-decoration: none;\n  border: 2px solid transparent;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.btnPrimary {\n  background: #e25c1d;\n  color: #ffffff;\n}\n\n.btnPrimary:hover {\n  background: #c94e14;\n  color: #ffffff;\n}\n\n.btnSecondary {\n  background: #ffffff;\n  color: #e25c1d;\n  border-color: #e25c1d;\n}\n\n.btnSecondary:hover {\n  background: #fff0eb;\n  color: #c94e14;\n}\n\n.btnGhost {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: none;\n  border: none;\n  color: #e25c1d;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  padding: 0;\n  text-decoration: none;\n}\n\n.btnGhost:hover {\n  text-decoration: underline;\n}\n\n/* —— Sections —— */\n.section {\n  padding: 2.5rem 0;\n}\n\n.sectionAlt {\n  background: #f8fafc;\n  padding: 2.75rem 0;\n}\n\n.sectionHeader {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.sectionTitle {\n  font-size: clamp(1.5rem, 3vw, 1.875rem);\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 0.65rem;\n}\n\n.sectionSubtitle {\n  max-width: 640px;\n  margin: 0 auto;\n  color: #64748b;\n  line-height: 1.65;\n  font-size: 1.05rem;\n}\n\n/* —— Category / feature cards —— */\n.cardGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.5rem;\n}\n\n.cardGrid3 {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1.25rem;\n}\n\n.card {\n  background: #ffffff;\n  border: 1px solid #eef2f7;\n  border-radius: 14px;\n  padding: 1.75rem;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  text-decoration: none;\n  color: inherit;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\na.card:hover {\n  border-color: #fdba8c;\n  box-shadow: 0 12px 28px rgba(226, 92, 29, 0.1);\n}\n\n.cardIcon {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1rem;\n  background: #fff0eb;\n  color: #e25c1d;\n  flex-shrink: 0;\n}\n\n.cardTitle {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 0.5rem;\n}\n\n.cardText {\n  margin: 0 0 1rem;\n  color: #64748b;\n  line-height: 1.6;\n  flex: 1;\n}\n\n.cardLink {\n  color: #e25c1d;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n/* —— Trust / signal row —— */\n.signalList {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1.25rem;\n}\n\n.signalItem {\n  text-align: center;\n  padding: 1.5rem 1rem;\n}\n\n.signalItem h3 {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0.75rem 0 0.4rem;\n}\n\n.signalItem p {\n  margin: 0;\n  color: #64748b;\n  line-height: 1.55;\n  font-size: 0.95rem;\n}\n\n/* —— Inquiry module —— */\n.inquiryWrap {\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  gap: 2rem;\n  align-items: start;\n}\n\n.inquiryPanel {\n  background: #ffffff;\n  border: 1px solid #eef2f7;\n  border-radius: 14px;\n  padding: 1.75rem;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);\n}\n\n.inquiryPanel h2 {\n  font-size: 1.35rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem;\n  color: #0f172a;\n}\n\n.inquiryPanel > p {\n  margin: 0 0 1.25rem;\n  color: #64748b;\n  line-height: 1.55;\n}\n\n.formGrid {\n  display: grid;\n  gap: 0.85rem;\n}\n\n.formField label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #334155;\n  margin-bottom: 0.35rem;\n}\n\n.formField input,\n.formField select,\n.formField textarea {\n  width: 100%;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 0.65rem 0.85rem;\n  font-size: 0.95rem;\n  color: #0f172a;\n  background: #fff;\n  font-family: inherit;\n}\n\n.formField input:focus,\n.formField select:focus,\n.formField textarea:focus {\n  outline: 2px solid rgba(226, 92, 29, 0.35);\n  border-color: #e25c1d;\n}\n\n.formField textarea {\n  min-height: 96px;\n  resize: vertical;\n}\n\n.formNote {\n  margin: 0.75rem 0 0;\n  font-size: 0.8rem;\n  color: #94a3b8;\n}\n\n.formSuccess {\n  margin: 0.75rem 0 0;\n  color: #15803d;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n/* —— Benefits list —— */\n.benefitList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 1rem;\n}\n\n.benefitItem {\n  display: flex;\n  gap: 0.85rem;\n  align-items: flex-start;\n  padding: 1rem 1.15rem;\n  background: #ffffff;\n  border: 1px solid #eef2f7;\n  border-radius: 12px;\n}\n\n.benefitItem strong {\n  display: block;\n  color: #0f172a;\n  margin-bottom: 0.2rem;\n}\n\n.benefitItem span {\n  color: #64748b;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n/* —— FAQ —— */\n.faqList {\n  max-width: 800px;\n  margin: 0 auto;\n  display: grid;\n  gap: 0.65rem;\n}\n\n.faqItem {\n  border: 1px solid #eef2f7;\n  border-radius: 12px;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n.faqQuestion {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1.15rem;\n  background: none;\n  border: none;\n  text-align: left;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #0f172a;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.faqQuestion:hover {\n  background: #f8fafc;\n}\n\n.faqIcon {\n  flex-shrink: 0;\n  color: #e25c1d;\n  transition: transform 0.2s ease;\n}\n\n.faqIconOpen {\n  transform: rotate(180deg);\n}\n\n.faqAnswer {\n  padding: 0 1.15rem 1.1rem;\n  color: #64748b;\n  line-height: 1.65;\n  font-size: 0.975rem;\n}\n\n/* —— Footer CTA band —— */\n.ctaBand {\n  background: linear-gradient(135deg, #fff7f2 0%, #fff0eb 50%, #f8fafc 100%);\n  padding: 3rem 0;\n  text-align: center;\n}\n\n.ctaBand h2 {\n  font-size: clamp(1.4rem, 3vw, 1.75rem);\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 0.65rem;\n}\n\n.ctaBand p {\n  max-width: 560px;\n  margin: 0 auto 1.5rem;\n  color: #64748b;\n  line-height: 1.6;\n}\n\n/* —— Page footer strip —— */\n.pageFooter {\n  border-top: 1px solid #eef2f7;\n  padding: 1.5rem 0;\n  text-align: center;\n  font-size: 0.875rem;\n  color: #94a3b8;\n}\n\n.pageFooter a {\n  color: #e25c1d;\n  text-decoration: none;\n}\n\n.pageFooter a:hover {\n  text-decoration: underline;\n}\n\n/* —— Salary / educational content —— */\n.proseSection {\n  padding: 2.75rem 0;\n}\n\n.proseNarrow {\n  max-width: 820px;\n  margin: 0 auto;\n}\n\n.proseLead {\n  font-size: 1.05rem;\n  line-height: 1.75;\n  color: #475569;\n  margin: 0 0 1.75rem;\n}\n\n.proseBlock {\n  margin-bottom: 2.25rem;\n}\n\n.proseBlock h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 0.65rem;\n}\n\n.proseBlock h4 {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 1.25rem 0 0.5rem;\n}\n\n.proseBlock p {\n  margin: 0 0 0.85rem;\n  color: #475569;\n  line-height: 1.7;\n}\n\n.metaRow {\n  display: grid;\n  gap: 0.45rem;\n  margin: 0 0 1rem;\n  padding: 0.9rem 1rem;\n  background: #f8fafc;\n  border: 1px solid #eef2f7;\n  border-radius: 10px;\n}\n\n.metaRow span {\n  color: #334155;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.metaRow strong {\n  color: #0f172a;\n}\n\n.bulletList {\n  margin: 0.5rem 0 1rem;\n  padding-left: 1.2rem;\n  color: #475569;\n  line-height: 1.7;\n}\n\n.bulletList li {\n  margin-bottom: 0.4rem;\n}\n\n.tableWrap {\n  overflow-x: auto;\n  margin: 1.25rem 0 2rem;\n  border: 1px solid #eef2f7;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);\n}\n\n.salaryTable {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 640px;\n  background: #ffffff;\n}\n\n.salaryTable th,\n.salaryTable td {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid #eef2f7;\n  font-size: 0.925rem;\n  vertical-align: top;\n}\n\n.salaryTable th {\n  background: #fff7f2;\n  color: #0f172a;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.salaryTable tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.salaryTable tbody tr:hover td {\n  background: #fafafa;\n}\n\n.factorGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1.15rem;\n  margin-top: 1.25rem;\n}\n\n.factorCard {\n  background: #ffffff;\n  border: 1px solid #eef2f7;\n  border-radius: 12px;\n  padding: 1.35rem;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);\n}\n\n.factorCard h3 {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 0.5rem;\n}\n\n.factorCard p {\n  margin: 0;\n  color: #64748b;\n  line-height: 1.6;\n  font-size: 0.95rem;\n}\n\n.inlineCta {\n  margin-top: 2rem;\n  padding: 1.5rem;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #fff7f2 0%, #ffffff 100%);\n  border: 1px solid #fde6d8;\n  text-align: center;\n}\n\n.inlineCta p {\n  margin: 0 0 1rem;\n  color: #475569;\n  line-height: 1.6;\n}\n\n/* —— Above-footer: resources + app download (not site footer) —— */\n.preFooter {\n  background: #fff5f0;\n  border-top: 1px solid #fde8dc;\n  padding: 2.75rem 0 3rem;\n}\n\n.preFooterInner {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 1.25rem;\n  display: grid;\n  grid-template-columns: 1fr 1.05fr;\n  gap: 2.5rem;\n  align-items: center;\n}\n\n.preFooterLinks {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n}\n\n.preFooterCol {\n  min-width: 0;\n}\n\n.preFooterHeading {\n  margin: 0 0 1rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #0f172a;\n}\n\n.preFooterList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 0.65rem;\n}\n\n.preFooterList a {\n  color: #64748b;\n  text-decoration: none;\n  font-size: 0.975rem;\n  line-height: 1.4;\n}\n\n.preFooterList a:hover {\n  color: #e25c1d;\n  text-decoration: underline;\n}\n\n.appDownloadCard {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 1.75rem 1.5rem;\n  border: 1px solid #f1f5f9;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);\n}\n\n.appDownloadTitle {\n  margin: 0 0 0.5rem;\n  font-size: clamp(1.15rem, 2.2vw, 1.4rem);\n  font-weight: 700;\n  line-height: 1.35;\n  color: #0f172a;\n}\n\n.appDownloadSubtext {\n  margin: 0 0 1.25rem;\n  font-size: 0.975rem;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n.appBadgeRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.appBadgeLink {\n  display: inline-flex;\n  line-height: 0;\n}\n\n.appBadge {\n  height: 44px;\n  width: auto;\n  max-width: 160px;\n  object-fit: contain;\n  display: block;\n}\n\n.proTip {\n  margin: 1rem 0 0;\n  padding: 0.9rem 1rem;\n  border-left: 3px solid #e25c1d;\n  background: #fff7f2;\n  border-radius: 0 10px 10px 0;\n  color: #475569;\n  line-height: 1.6;\n  font-size: 0.95rem;\n}\n\n.stepList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 1.5rem;\n  counter-reset: hire-step;\n}\n\n.stepCard {\n  background: #ffffff;\n  border: 1px solid #eef2f7;\n  border-radius: 14px;\n  padding: 1.5rem 1.5rem 1.35rem;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);\n  counter-increment: hire-step;\n}\n\n.stepCard h2 {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 0.85rem;\n  line-height: 1.35;\n}\n\n.stepCard h2::before {\n  content: counter(hire-step);\n  flex-shrink: 0;\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 999px;\n  background: #fff0eb;\n  color: #e25c1d;\n  font-size: 0.9rem;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0.1rem;\n}\n\n.stepCard > p {\n  margin: 0 0 0.85rem;\n  color: #475569;\n  line-height: 1.7;\n}\n\n.stepCard h3 {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 1rem 0 0.5rem;\n}\n\n.orderedQuestions {\n  margin: 0.5rem 0 0;\n  padding-left: 1.25rem;\n  color: #475569;\n  line-height: 1.7;\n}\n\n.orderedQuestions li {\n  margin-bottom: 0.55rem;\n}\n\n/* —— Knowledge Hub (sticky sidebar + content) —— */\n.hubHero {\n  padding: 2rem 0 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.hubHeroInner {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 1.25rem;\n}\n\n.hubHero .heroTitle {\n  text-align: left;\n  margin-bottom: 0.85rem;\n}\n\n.hubHero .heroSubtitle {\n  margin: 0 0 1.25rem;\n  max-width: 720px;\n  text-align: left;\n}\n\n.hubHero .ctaRow {\n  justify-content: flex-start;\n}\n\n.hubBody {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 1.75rem 1.25rem 3rem;\n  display: grid;\n  grid-template-columns: minmax(200px, 1fr) minmax(0, 3fr);\n  gap: 2rem;\n  align-items: start;\n}\n\n.hubSidebar {\n  position: sticky;\n  top: 5rem;\n  align-self: start;\n  max-height: calc(100vh - 6rem);\n  overflow-y: auto;\n  padding: 0.25rem 0;\n}\n\n.hubNavLabel {\n  margin: 0 0 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  padding-left: 0.85rem;\n}\n\n.hubNavList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  border-left: 1px solid #e2e8f0;\n}\n\n.hubNavLink {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 0.65rem 0.85rem;\n  border: none;\n  border-left: 4px solid transparent;\n  margin-left: -1px;\n  background: transparent;\n  color: #64748b;\n  font-size: 0.9rem;\n  font-weight: 500;\n  line-height: 1.35;\n  cursor: pointer;\n  font-family: inherit;\n  text-decoration: none;\n  border-radius: 0 8px 8px 0;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.hubNavLink:hover {\n  color: #e25c1d;\n  background: #fff7f2;\n}\n\n.hubNavLinkActive {\n  border-left-color: #f97316;\n  background: #fff7ed;\n  color: #ea580c;\n  font-weight: 600;\n}\n\n.hubMain {\n  min-width: 0;\n  display: grid;\n  gap: 1.25rem;\n}\n\n.hubTopic {\n  scroll-margin-top: 6rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 1.5rem 1.5rem 1.35rem;\n  background: #ffffff;\n}\n\n.hubTopicHeader {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem;\n  margin-bottom: 0.75rem;\n}\n\n.hubTopicHeader h2 {\n  margin: 0;\n  font-size: clamp(1.2rem, 2.4vw, 1.45rem);\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.3;\n}\n\n.hubBadge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  background: #fff0eb;\n  color: #e25c1d;\n  border: 1px solid #fde6d8;\n}\n\n.hubBadgeGuide {\n  background: #eff6ff;\n  color: #2563eb;\n  border-color: #dbeafe;\n}\n\n.hubBadgeOps {\n  background: #f0fdf4;\n  color: #15803d;\n  border-color: #bbf7d0;\n}\n\n.hubBadgeHire {\n  background: #faf5ff;\n  color: #7c3aed;\n  border-color: #e9d5ff;\n}\n\n.hubSummary {\n  margin: 0 0 1rem;\n  color: #475569;\n  line-height: 1.7;\n  font-size: 0.975rem;\n}\n\n.hubTopic .bulletList {\n  margin-bottom: 1.15rem;\n}\n\n.hubTopic .salaryTable {\n  min-width: 480px;\n}\n\n.hubTopic .tableWrap {\n  margin: 0 0 1.15rem;\n}\n\n.hubTopicCtas {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n  margin-top: 0.25rem;\n}\n\n.hubQuickCards {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.85rem;\n  margin: 0 0 1.15rem;\n}\n\n.hubQuickCard {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.9rem 1rem;\n  background: #f8fafc;\n}\n\n.hubQuickCard strong {\n  display: block;\n  color: #0f172a;\n  font-size: 0.9rem;\n  margin-bottom: 0.25rem;\n}\n\n.hubQuickCard span {\n  color: #64748b;\n  font-size: 0.85rem;\n  line-height: 1.45;\n}\n\n@media (max-width: 900px) {\n  .factorGrid,\n  .cardGrid3,\n  .signalList,\n  .hubQuickCards {\n    grid-template-columns: 1fr;\n  }\n\n  .inquiryWrap,\n  .preFooterInner {\n    grid-template-columns: 1fr;\n  }\n\n  .hubBody {\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n    padding-top: 1.25rem;\n  }\n\n  .hubSidebar {\n    position: sticky;\n    top: 3.5rem;\n    z-index: 20;\n    max-height: none;\n    overflow: visible;\n    margin: 0 -1.25rem;\n    padding: 0.65rem 0;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n  }\n\n  .hubNavLabel {\n    display: none;\n  }\n\n  .hubNavList {\n    flex-direction: row;\n    overflow-x: auto;\n    gap: 0.4rem;\n    border-left: none;\n    padding: 0 1.25rem 0.35rem;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n  }\n\n  .hubNavLink {\n    flex: 0 0 auto;\n    white-space: nowrap;\n    border-left: none;\n    border-bottom: 3px solid transparent;\n    margin-left: 0;\n    border-radius: 8px;\n    padding: 0.55rem 0.85rem;\n    background: #f8fafc;\n  }\n\n  .hubNavLinkActive {\n    border-left-color: transparent;\n    border-bottom-color: #f97316;\n    background: #fff7ed;\n  }\n}\n\n@media (max-width: 640px) {\n  .cardGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .hero {\n    padding-top: 1.75rem;\n  }\n\n  .ctaRow {\n    flex-direction: column;\n  }\n\n  .btnPrimary,\n  .btnSecondary {\n    width: 100%;\n  }\n\n  .preFooterLinks {\n    grid-template-columns: 1fr;\n    gap: 1.75rem;\n  }\n\n  .appBadge {\n    height: 42px;\n    max-width: 148px;\n  }\n\n  .hubTopic {\n    padding: 1.25rem 1.1rem;\n  }\n\n  .hubTopicCtas .btnPrimary,\n  .hubTopicCtas .btnSecondary {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ContentPages_page__Xe6GN`,
	"container": `ContentPages_container__DVDeq`,
	"breadcrumb": `ContentPages_breadcrumb__prZoY`,
	"breadcrumbList": `ContentPages_breadcrumbList__f4nNQ`,
	"breadcrumbLink": `ContentPages_breadcrumbLink__s6Hu-`,
	"breadcrumbSep": `ContentPages_breadcrumbSep__JKgRo`,
	"breadcrumbCurrent": `ContentPages_breadcrumbCurrent__rvHpQ`,
	"hero": `ContentPages_hero__nkQg3`,
	"heroWide": `ContentPages_heroWide__nvvNp`,
	"heroEyebrow": `ContentPages_heroEyebrow__F4k1Y`,
	"heroTitle": `ContentPages_heroTitle__92mQY`,
	"heroAccent": `ContentPages_heroAccent__tXG-E`,
	"heroSubtitle": `ContentPages_heroSubtitle__jgUgQ`,
	"ctaRow": `ContentPages_ctaRow__GkMYZ`,
	"btnPrimary": `ContentPages_btnPrimary__S4GiF`,
	"btnSecondary": `ContentPages_btnSecondary__b3g2l`,
	"btnGhost": `ContentPages_btnGhost__vJxat`,
	"section": `ContentPages_section__L6GVF`,
	"sectionAlt": `ContentPages_sectionAlt__0EWE7`,
	"sectionHeader": `ContentPages_sectionHeader__SPlCp`,
	"sectionTitle": `ContentPages_sectionTitle__3eUVc`,
	"sectionSubtitle": `ContentPages_sectionSubtitle__XLWYe`,
	"cardGrid": `ContentPages_cardGrid__AIHnP`,
	"cardGrid3": `ContentPages_cardGrid3__mTXX3`,
	"card": `ContentPages_card__1ViuB`,
	"cardIcon": `ContentPages_cardIcon__Q01Lb`,
	"cardTitle": `ContentPages_cardTitle__3h6ry`,
	"cardText": `ContentPages_cardText__X2gjm`,
	"cardLink": `ContentPages_cardLink__pFBj4`,
	"signalList": `ContentPages_signalList__MK1TY`,
	"signalItem": `ContentPages_signalItem__tXiF8`,
	"inquiryWrap": `ContentPages_inquiryWrap__JQbN2`,
	"inquiryPanel": `ContentPages_inquiryPanel__xHC30`,
	"formGrid": `ContentPages_formGrid__b+-vU`,
	"formField": `ContentPages_formField__mBi6x`,
	"formNote": `ContentPages_formNote__Lxpwd`,
	"formSuccess": `ContentPages_formSuccess__v7bMP`,
	"benefitList": `ContentPages_benefitList__+iZlY`,
	"benefitItem": `ContentPages_benefitItem__9PyJE`,
	"faqList": `ContentPages_faqList__BrIUl`,
	"faqItem": `ContentPages_faqItem__Tlu+J`,
	"faqQuestion": `ContentPages_faqQuestion__qowiv`,
	"faqIcon": `ContentPages_faqIcon__vavdu`,
	"faqIconOpen": `ContentPages_faqIconOpen__tV--o`,
	"faqAnswer": `ContentPages_faqAnswer__0dEKx`,
	"ctaBand": `ContentPages_ctaBand__PcH0j`,
	"pageFooter": `ContentPages_pageFooter__hkrdz`,
	"proseSection": `ContentPages_proseSection__DU-gz`,
	"proseNarrow": `ContentPages_proseNarrow__yiX1Q`,
	"proseLead": `ContentPages_proseLead__LAbq2`,
	"proseBlock": `ContentPages_proseBlock__nrMdr`,
	"metaRow": `ContentPages_metaRow__VlrQa`,
	"bulletList": `ContentPages_bulletList__26OoQ`,
	"tableWrap": `ContentPages_tableWrap__l3Xbk`,
	"salaryTable": `ContentPages_salaryTable__6vjj6`,
	"factorGrid": `ContentPages_factorGrid__1KoId`,
	"factorCard": `ContentPages_factorCard__ZSy5-`,
	"inlineCta": `ContentPages_inlineCta__g4eW2`,
	"preFooter": `ContentPages_preFooter__2fuwt`,
	"preFooterInner": `ContentPages_preFooterInner__Ce+Jl`,
	"preFooterLinks": `ContentPages_preFooterLinks__7I1+y`,
	"preFooterCol": `ContentPages_preFooterCol__bl5cv`,
	"preFooterHeading": `ContentPages_preFooterHeading__3uAze`,
	"preFooterList": `ContentPages_preFooterList__mEC-p`,
	"appDownloadCard": `ContentPages_appDownloadCard__ONYzJ`,
	"appDownloadTitle": `ContentPages_appDownloadTitle__-3a-h`,
	"appDownloadSubtext": `ContentPages_appDownloadSubtext__W8NlG`,
	"appBadgeRow": `ContentPages_appBadgeRow__j6-wc`,
	"appBadgeLink": `ContentPages_appBadgeLink__5+Bqp`,
	"appBadge": `ContentPages_appBadge__Ie66x`,
	"proTip": `ContentPages_proTip__inTSk`,
	"stepList": `ContentPages_stepList__0V28I`,
	"stepCard": `ContentPages_stepCard__POC37`,
	"orderedQuestions": `ContentPages_orderedQuestions__kyaTL`,
	"hubHero": `ContentPages_hubHero__bp8PM`,
	"hubHeroInner": `ContentPages_hubHeroInner__nINTz`,
	"hubBody": `ContentPages_hubBody__owwup`,
	"hubSidebar": `ContentPages_hubSidebar__QBUzw`,
	"hubNavLabel": `ContentPages_hubNavLabel__KFina`,
	"hubNavList": `ContentPages_hubNavList__X0nYJ`,
	"hubNavLink": `ContentPages_hubNavLink__CoIgV`,
	"hubNavLinkActive": `ContentPages_hubNavLinkActive__miBgj`,
	"hubMain": `ContentPages_hubMain__0hLxs`,
	"hubTopic": `ContentPages_hubTopic__poeqb`,
	"hubTopicHeader": `ContentPages_hubTopicHeader__V+uSt`,
	"hubBadge": `ContentPages_hubBadge__ZjF3L`,
	"hubBadgeGuide": `ContentPages_hubBadgeGuide__Kqnad`,
	"hubBadgeOps": `ContentPages_hubBadgeOps__xN3CU`,
	"hubBadgeHire": `ContentPages_hubBadgeHire__rP8uE`,
	"hubSummary": `ContentPages_hubSummary__h3s4y`,
	"hubTopicCtas": `ContentPages_hubTopicCtas__3WE90`,
	"hubQuickCards": `ContentPages_hubQuickCards__INC-0`,
	"hubQuickCard": `ContentPages_hubQuickCard__zCAcH`
};
export default ___CSS_LOADER_EXPORT___;
